module.exports = __webpack_public_path__ + "static/img/公司二维码.54a6400.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/公司二维码.jpg
// module id = 6Rxm
// module chunks = 15